import { createElement, lazy } from "react";
import { useLocation } from "react-router-dom";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const CalculatedFiltersEditRoute = lazy(async () => {
  const [{ CalculatedFilterEditNRO }, { CustomObjectCalculatedFilterEditNRO }] = await Promise.all([
    import("@segments/CalculatedFilterEdit"),
    import("@segments/CustomObjectCalculatedFilter"),
  ]);

  const Route = (): React.ReactElement => {
    const { search } = useLocation();
    const isCustomObjectRoute = new URLSearchParams(search).get("type") === "DATA_OBJECTS_FILTER";

    if (isCustomObjectRoute) {
      return createElement(CustomObjectCalculatedFilterEditNRO);
    }

    return createElement(CalculatedFilterEditNRO);
  };

  return { default: Route };
});

export const calculatedFiltersEditNRO: NavigationRoutingObject = {
  Component: CalculatedFiltersEditRoute,
  componentFeatureFlippers: ["calculated_filters"],
  noKnockoutFallback: true,
  section: "audience",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("calculated-filters-edit-page-heading", "Edit Calculated Filter"),
  pageNameForTracking: () => "Edit Calculated Filter",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("calculated_filters");
  },
  showInSearchResults: false,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/calculated_filters/:appGroupId",
};
